module.exports = __webpack_public_path__ + "img/古灵.54f3950a.png";